var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { RadixInput } from "./RadixInput";
var MAX_PHONE_DIGITS = 10;
var toPhoneDigits = function (value) {
    var digits = [];
    for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
        var character = value_1[_i];
        if (character >= "0" && character <= "9") {
            digits.push(character);
        }
        if (digits.length === MAX_PHONE_DIGITS) {
            break;
        }
    }
    return digits.join("");
};
var toPhoneDisplayValue = function (value) {
    var digits = toPhoneDigits(value);
    if (digits.length <= 3) {
        return digits;
    }
    if (digits.length <= 6) {
        return "".concat(digits.slice(0, 3), "-").concat(digits.slice(3));
    }
    return "".concat(digits.slice(0, 3), "-").concat(digits.slice(3, 6), "-").concat(digits.slice(6));
};
export var RadixPhoneInput = React.forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var _e = _a.value, value = _e === void 0 ? "" : _e, onValueChange = _a.onValueChange, onBlur = _a.onBlur, props = __rest(_a, ["value", "onValueChange", "onBlur"]);
    var formattedValue = toPhoneDisplayValue(value);
    var handleChange = React.useCallback(function (event) {
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(toPhoneDisplayValue(event.target.value));
    }, [onValueChange]);
    return (React.createElement(RadixInput, __assign({}, props, { ref: ref, type: "tel", autoComplete: (_b = props.autoComplete) !== null && _b !== void 0 ? _b : "tel", value: formattedValue, onChange: handleChange, onBlur: onBlur, inputMode: (_c = props.inputMode) !== null && _c !== void 0 ? _c : "numeric", maxLength: 12, placeholder: (_d = props.placeholder) !== null && _d !== void 0 ? _d : "XXX-XXX-XXXX" })));
});
RadixPhoneInput.displayName = "RadixPhoneInput";
